import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=6b3d9292&"
import script from "./Cover.vue?vue&type=script&lang=js&"
export * from "./Cover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports